export default "__VITE_ASSET__9FA9_4OT__"